import { render } from "./AiWorkspace.vue?vue&type=template&id=37d7af5b"
import script from "./AiWorkspace.vue?vue&type=script&lang=js"
export * from "./AiWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__